import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../../progressiveapp/assetsprogressive/button.png";
import symbol from "../../progressiveapp/assetsprogressive/symbol.png";
import f1 from "../../progressiveapp/assetsprogressive/pic1.png";
import f2 from "../../progressiveapp/assetsprogressive/pic2.png";
import f3 from "../../progressiveapp/assetsprogressive/pic3.png";
import f4 from "../../progressiveapp/assetsprogressive/pic4.png";
const Testimonial = () => {
  const data = [
     {
       id: 1,
       image: f1,
       name: "Joey",
       position: "—  Ukraine, Russia",
       feedback:
         "The team demonstrated a deep understanding of Web3 architecture and user experience. The platform delivered strong performance from day one and scaled smoothly as usage increased..",
     },
     {
       id: 2,
       image: f2,
       name: "Justine Bill",
       position: "– Los Angeles, California",
       feedback:
         "From planning to deployment, the execution was structured and transparent. What stood out most was the focus on usability and long-term scalability rather than just features.",
     },
     {
       id: 3,
       image: f3,
       name: "Arjun Iyer",
       position: "– Jaipur, India",
       feedback:
         "Technical clarity, timely delivery, and reliable post-launch support made a real difference for our project. The marketplace is stable, intuitive, and well-optimized for growth.",
     },
     {
       id: 4,
       image: f4,
       name: "Nikhil Verma",
       position: "— Bengaluru, India",
       feedback:
         "Clear technical direction and thoughtful execution helped us avoid common scaling issues. The team focused on building a product that performs reliably in real-world usage, not just on paper.",
     },
   ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id='metaverse-testimonials' className="progressive-wrapper">
       <div className="container-main">
            <h2 className="heading">
          Trusted by Our Clients
            </h2>
            {/* <p className="subHeading">
            We build trust through proven client experiences, delivering reliable CRM solutions that drive measurable results and long-term business growth.
            </p> */}
            <Slider {...settings}>
                {data.map((item) => {
                    return (
                        <div className="fwrapper" key={item.id}>
                            <div className="fbox">
                                <div className="symbolbox">
                                    <img src={symbol} alt="" className="symbolimage" />
                                </div>
                                <div className="fcontent">
                                    <p>{item.feedback}</p>
                                    <div className="personinfo">
                                        <h3>{item.name}</h3>
                                        <h4>{item.position}</h4>
                                    </div>
                                </div>
                                <div className="profilebox">
                                    <img src={item.image} alt="" className="profileimage" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
    </div>
</div>
  );
};

export default Testimonial;
